let ws = null;
let rIndex = 0;
let connected = false;
const timeout = 2000

function arrayBufferToBase64( buffer ) {
    let binary = '';
    const bytes = new Uint8Array( buffer );
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
        binary += String.fromCharCode( bytes[ i ] );
    }
    return window.btoa( binary );
}

export default {
    isInstalled(){
        return typeof WebSocket !== "undefined";
    },
    connect(name){
        ws = new WebSocket(process.env.VUE_APP_WS_PRINTER_URL);
        return new Promise((resolve, reject) => {
            const rid = ++rIndex;
            let hasReturned = false

            setTimeout(function () {
                if (!hasReturned) {
                    hasReturned = true
                    reject(new Error("TIMEOUT"))
                }
            }, timeout)

            ws.addEventListener('open', function () {
                if (hasReturned) {
                    ws.close()
                    return
                }
                ws.send(JSON.stringify({rid: rid, command: "connect", params: {name: name}}));
            });
            const messageHandler = function(event){
                if (hasReturned) {
                    ws.close()
                    return
                }
                const response = JSON.parse(event.data);
                if(response.rid !== rid){
                    return;
                }
                ws.removeEventListener('message', messageHandler);
                ws.removeEventListener('error', errorHandler);
                if(response.data === "OK") {
                    connected = true;
                    hasReturned = true
                    resolve();
                }else{
                    ws.close();
                    ws = null;
                    connected = false;
                    hasReturned = true
                    reject();
                }
            };
            const errorHandler = function(){
                if (hasReturned) {
                    return
                }
                ws = null;
                connected = false;
                hasReturned = true
                reject();
            };
            ws.addEventListener('message', messageHandler);
            ws.addEventListener('error', errorHandler);
        });
    },
    disconnect(){
        return new Promise((resolve, reject) => {
            if(!ws || ws.readyState === ws.CLOSED || ws.readyState === ws.CLOSING){
                connected = false;
                reject(new Error("Impressora já desconectada"));
                return;
            }
            const rid = ++rIndex;
            const messageHandler = function(event){
                const response = JSON.parse(event.data);
                if(response.rid !== rid){
                    return;
                }
                ws.removeEventListener('message', messageHandler);
                ws.removeEventListener('error', errorHandler);
                ws.close();
                ws = null;
                if(response.data === "OK") {
                    connected = false;
                    resolve();
                }else{
                    connected = false;
                    reject();
                }
            };
            const errorHandler = function(){
                ws = null;
                connected = false;
                reject();
            };
            ws.addEventListener('message', messageHandler);
            ws.addEventListener('error', errorHandler);
            ws.send(JSON.stringify({rid: rid, command: "disconnect"}));
        });
    },
    list(){
        return new Promise((resolve, reject) => {
            let alreadyConnected = false;
            const rid = ++rIndex;
            let hasReturned = false

            setTimeout(function () {
                if (!hasReturned) {
                    hasReturned = true
                    reject(new Error("TIMEOUT"))
                }
            }, timeout)

            const messageHandler = function(event){
                if (hasReturned) {
                    if(!alreadyConnected) {
                        ws.close();
                        ws = null;
                    }
                    return
                }
                const response = JSON.parse(event.data);
                if(response.rid !== rid){
                    return;
                }
                ws.removeEventListener('message', messageHandler);
                ws.removeEventListener('error', errorHandler);
                if(!alreadyConnected) {
                    ws.close();
                    ws = null;
                }
                if(!response.error) {
                    hasReturned = true
                    resolve(response.data.map(printerName => {
                        return {
                            name: printerName,
                            id: printerName
                        }
                    }));
                }else{
                    hasReturned = true
                    reject(new Error(response.error));
                }
            };
            const errorHandler = function(){
                ws = null;
                if (!hasReturned) {
                    hasReturned = true
                    reject();
                }
            };
            if(ws && ws.readyState === ws.OPEN){
                alreadyConnected = true;
                ws.addEventListener('message', messageHandler);
                ws.addEventListener('error', errorHandler);
                ws.send(JSON.stringify({rid: rid, command: "list"}));
            }else{
                ws = new WebSocket(process.env.VUE_APP_WS_PRINTER_URL);
                ws.addEventListener('open', function () {
                    ws.send(JSON.stringify({rid: rid, command: "list"}));
                });
                ws.addEventListener('message', messageHandler);
                ws.addEventListener('error', errorHandler);
            }
        });
    },
    isConnected(){
        return connected;
    },
    write(data){
        return new Promise((resolve, reject) => {
            if(!connected || !ws || ws.readyState !== ws.OPEN){
                connected = false;
                reject(new Error("Impressora desconectada"));
                return;
            }
            const rid = ++rIndex;
            const messageHandler = function(event){
                const response = JSON.parse(event.data);
                if(response.rid !== rid){
                    return;
                }
                ws.removeEventListener('message', messageHandler);
                ws.removeEventListener('error', errorHandler);
                if(response.data === "OK") {
                    resolve();
                }else{
                    reject(new Error(response.error));
                }
            };
            const errorHandler = function(){
                ws = null;
                reject(new Error("Falha na conexão com a impressora"));
            };
            ws.addEventListener('message', messageHandler);
            ws.addEventListener('error', errorHandler);
            ws.send(JSON.stringify({rid: rid, command: "write", params: {data: arrayBufferToBase64(data)}}));
        });
    }
};
